import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const LINKS = [
  { href: "#manifesto", label: "The Movement" },
  { href: "#calendar", label: "Calendar" },
  { href: "#bears", label: "1,000 Bears" },
  { href: "#ball", label: "The Ball" },
  { href: "#pledge", label: "Pledge" },
];

export function Nav() {
  const { user, logout, openAuth } = useAuth();

  const go = (href) => (e) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#33240E]/15 bg-[#F6E7C1]/80 backdrop-blur-xl" data-testid="main-nav">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <a href="#top" onClick={go("#top")} className="group" data-testid="nav-logo">
          <span className="block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8A5A0F]">Be Kind Community Inc</span>
          <span className="block font-serif text-xl italic text-[#33240E] transition-colors duration-300 group-hover:text-[#8A5A0F]">The Kindness Ball</span>
        </a>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={go(l.href)} data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground transition-colors duration-300 hover:text-[#8A5A0F]">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          {user?.role === "admin" && (
            <a href="/admin" data-testid="nav-admin-link"
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#9E3C3C] transition-colors duration-300 hover:text-[#33240E]">
              VIP Board
            </a>
          )}
          {user ? (
            <>
              <span className="hidden font-mono text-[11px] uppercase tracking-[0.2em] text-[#8A5A0F] sm:block" data-testid="nav-user-name">
                {user.name.split(" ")[0]}
              </span>
              <button onClick={async () => { await logout(); toast.success("Signed out. See you tomorrow."); }} data-testid="nav-logout-button"
                className="border border-[#33240E]/25 px-5 py-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#33240E] transition-colors duration-300 hover:border-[#8A5A0F] hover:text-[#8A5A0F]">
                Sign Out
              </button>
            </>
          ) : (
            <button onClick={() => openAuth("login")} data-testid="nav-signin-button"
              className="bg-[#33240E] px-5 py-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#F6E7C1] transition-colors duration-300 hover:bg-[#4A3517]">
              Sign In
            </button>
          )}
        </div>
      </div>
      <nav className="flex gap-6 overflow-x-auto px-6 pb-3 lg:hidden" data-testid="mobile-nav" style={{ scrollbarWidth: "none" }}>
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} onClick={go(l.href)}
            className="shrink-0 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground transition-colors duration-300 hover:text-[#8A5A0F]">
            {l.label}
          </a>
        ))}
      </nav>
    </header>
  );
}
